// Display formatting helpers shared by public pages + admin.

// Price → "$2,500,000". Accepts a number (preferred, what the admin stores) or
// a legacy string like "S$2,180,000" (digits are extracted and reformatted).
export function formatPrice(value) {
  if (value === null || value === undefined || value === "") return "";
  const n =
    typeof value === "number"
      ? value
      : Number(String(value).replace(/[^0-9.]/g, ""));
  if (!isFinite(n) || n === 0) return typeof value === "string" ? value : "";
  return "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 });
}

// Size → "624 sqft". Accepts a number or a legacy string like "1,109 sqft".
export function formatSqft(value) {
  if (value === null || value === undefined || value === "") return "";
  const n =
    typeof value === "number"
      ? value
      : Number(String(value).replace(/[^0-9.]/g, ""));
  if (!isFinite(n) || n === 0) return typeof value === "string" ? value : "";
  return n.toLocaleString("en-US", { maximumFractionDigits: 0 }) + " sqft";
}

// Strip HTML tags → plain text, for card teasers / meta descriptions where we
// don't want to render markup.
export function stripHtml(html) {
  if (!html) return "";
  if (typeof document !== "undefined") {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").trim();
  }
  return String(html).replace(/<[^>]*>/g, "").trim();
}

export function truncate(text, max = 160) {
  const t = (text || "").trim();
  if (t.length <= max) return t;
  return t.slice(0, max).replace(/\s+\S*$/, "") + "…";
}

// Does an HTML/text value actually contain content? (TipTap emits "<p></p>" when empty.)
export function hasRichContent(html) {
  return stripHtml(html).length > 0;
}
